
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table } from "@common/src/utils/decorator";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import TableEnableFlag from "@/components/scope/table-enable-flag.vue";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
const warehouse = namespace("warehouse");
const parts = namespace("parts");
const base = namespace("base");
const inventory = namespace("inventory");
const partsCategory = namespace("parts-category");
const common_warehouse = namespace("common_warehouse");
const common_inventory = namespace("common_inventory");
const setting = namespace("setting");
@Component({
  components: { TableEnableFlag }
})
@Table("loadListData")
export default class Parts extends Vue {
  @common_inventory.State taxIncludeList;
  @inventory.Action getInventoryRecord;
  @parts.Action updateStatus;
  @partsCategory.Action getCategoryList;
  @base.Action getDictionaryList;
  @warehouse.Action getWarehouseList;
  @common_warehouse.Action queryWarehouseShelfTree;
  @setting.State fifoStatus;
  @setting.State productionBatchNoStatus;
  searchForm = {
    partsName: "",
    partsCategoryCode: "",
    inventoryDetailType: "",
    warehouseCode: "",
    shelfCode: "",
    associatedNumber: ""
  };
  splitThousands = splitThousands;
  dayjs = dayjs;
  emptyToLine = emptyToLine;
  sortForm: {};
  partsList: any[] = [];
  t = t;
  get searchList() {
    return [
      {
        label: "parts.name",
        type: "input",
        value: "",
        prop: "partsName"
      },
      {
        label: t("v216_g.parts_custom_code"),
        type: "input",
        value: "",
        prop: "partsCustomizeCode"
      },
      {
        label: t("v210.associated-issue-receipt-doc-no"),
        type: "input",
        value: "",
        prop: "associatedNumber"
      },
      {
        label: "parts.category",
        type: "cascader",
        prop: "partsCategoryCode",
        value: "",
        options: this.categoryList,
        props: {
          label: "categoryName",
          value: "categoryCode"
        }
      },
      {
        label: "base.type",
        type: "select",
        selectList: this.inventoryDetailTypeList,
        prop: "inventoryDetailType",
        value: ""
      },
      {
        label: t("warehouse.warehouse"),
        type: "select",
        selectList: this.warehouseList,
        clearMethod: this.handleSearchWarehouseClear,
        changeMethod: this.handleSearchWarehouseChange,
        prop: "warehouseCode",
        value: ""
      },
      {
        label: t("v210.location"),
        type: "select",
        value: "",
        selectList: this.shelfList,
        prop: "shelfCode",
        disabled: this.shelfSelectDiasabled,
        noKeepOld: true
      },
      this.fifoStatus === "1"
        ? {
            label: t("v216_g.inbound_batch_no"),
            type: "input",
            value: "",
            prop: "inboundBatchNo"
          }
        : {},
      {
        label: t("speedbiz-v217_0.Tax-included"),
        type: "select",
        value: "",
        selectList: this.taxIncludeList,
        prop: "taxIncluded"
      },
      this.productionBatchNoStatus === "1"
        ? {
            label: t("v216_g.production_batch_no"),
            type: "input",
            value: "",
            prop: "productionBatchNo"
          }
        : {},
      {
        label: t("v210.operation-time:"),
        type: "daterange",
        value: "",
        prop: "operatingTime"
      }
    ];
  }
  categoryList: any[] = [];
  warehouseList: any = [];
  inventoryDetailTypeList: any = [];
  created() {
    this.init();
  }
  async init() {
    this.loadListData();
    this.getDictionaryList("inventory_detail_type").then(data => {
      this.inventoryDetailTypeList = data;
    });
    this.queryWarehouseShelfTree({
      pageNum: 1,
      pageSize: 100
    }).then(data => {
      let list = this.$safeValue(data, "data.warehouseList", []);
      let warehouseList = [];
      list.forEach(item => {
        warehouseList.push({
          label: item.warehouseName,
          value: item.warehouseCode
        });
        if (!this.warehouseShelfMap[item.warehouseCode]) {
          this.warehouseShelfMap[item.warehouseCode] = item.shelfList;
        }
      });
      this.warehouseList = warehouseList;
    });
    const data = await this.getCategoryList();
    this.categoryList = this.addLeafFlag(this.$safeValue(data, "data", []));
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getInventoryRecord({
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize,
      partsName: this.searchForm.partsName
    }).then(data => {
      this.partsList = this.$safeValue(data, "data.list", []);
      return data;
    });
  }
  addLeafFlag(list) {
    const f = function (list) {
      list.forEach(item => {
        if (!item.children || item.children.length < 1) {
          delete item.children;
        } else {
          f(item.children);
        }
      });
    };
    f(list);
    return list;
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "operatingTime") {
          this.searchForm["operatingTimeBegin"] = item.value ? item.value[0] : "";
          this.searchForm["operatingTimeEnd"] = item.value ? item.value[1] : "";
        } else if (item.prop === "partsCategoryCode") {
          this.searchForm[item.prop] = item.value.slice(-1)[0];
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    console.log(this.searchForm);
    this.loadListData();
  }
  handleLinkPartsDetail(row) {
    let { href } = this.$router.resolve({
      path: `/setting/parts-edit/${row.partsCode}`
    });
    window.open(href, "_blank");
  }
  warehouseShelfMap: any = {};
  shelfList: any = [];
  shelfSelectDiasabled: boolean = true;
  handleSearchWarehouseChange(val) {
    this.shelfSelectDiasabled = false;
    this.searchForm.shelfCode = "";
    this.shelfList = (this.warehouseShelfMap[val] || []).map(item => {
      item.label = item.shelfDesc;
      item.value = item.shelfCode;
      return item;
    });
  }
  handleSearchWarehouseClear() {
    this.shelfSelectDiasabled = true;
  }
  handleLinkInOutView(row) {
    if (row.associatedNumber.includes("CK")) {
      let { href } = this.$router.resolve({
        path: `/inventory/out-warehouse-view/${row.associatedNumber}`
      });
      window.open(href, "_blank");
    } else if (row.associatedNumber.includes("RK")) {
      let { href } = this.$router.resolve({
        path: `/inventory/in-warehouse-view/${row.associatedNumber}`
      });
      window.open(href, "_blank");
    }
  }
}
